import React from 'react'
import Logo from '../assets/images/gym_logo.png'
import Stack from '@mui/material/Stack'
import { Link } from 'react-router-dom'

const Navbar = () => {
  return (
    <Stack direction="row" justifyContent="space-around"  sx={{gap: {sm:'122px',xs:'40px'} ,mt:{sm:'32px', xs:'20px'} , justifyContent:"none", px:"20"}}>
         <Link  to="/"> 
           <img src={Logo} alt="" style={{width: "70px"  ,height:'50px' , margin:'0 20px'}}/>
         </Link>  
            <Stack direction="row" gap='40px' fontSize="24px" alignItems="flex-end">
            <Link to="/" style={{ textDecoration : 'none' , color:"#3A1212" ,borderBottom:'3px solid #FF6252'} }>Home</Link>
             <a href='exercise' style={{ textDecoration : 'none' , color: "#3A1212" } }>Exercises</a>
          </Stack>
    </Stack>
  )
}
 
export default Navbar 
 